import multiguard from "vue-router-multiguard";
import {
    redirectLogin,
    loginRequired,
    isVerifiedCellphone,
    isVerifiedEmail,
    isRequestCellphoneForgetPassword,
    isVerifiedCellphoneForSmsVerification,
} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/RouterGuards";

// import auth views
import Login from "./defaultSiteRouteViews/auth/Login";
import Register from "./defaultSiteRouteViews/auth/Register";
import ForgetPassword from "./defaultSiteRouteViews/auth/ForgetPassword";
import EmailResetPassword from "./defaultSiteRouteViews/auth/ResetEmailPassword";
import CellphoneResetPassword from "./defaultSiteRouteViews/auth/ResetCellPhonePassword";
import VerifiedCellphone from "./defaultSiteRouteViews/auth/VerifiedCellphone";
import VerifiedEmail from "./defaultSiteRouteViews/auth/VerifiedEmail";

// site views
import Product from './defaultSiteRouteViews/site/SingleProduct'
import Products from './defaultSiteRouteViews/site/Products'
import SinglePost from "./defaultSiteRouteViews/site/SinglePost";
import SingleCourse from "./defaultSiteRouteViews/site/SingleCourse";
import Posts from "./defaultSiteRouteViews/site/Posts";
import Pages from "./defaultSiteRouteViews/site/Pages";
import Courses from "./defaultSiteRouteViews/site/Course";
import SinglePage from "./defaultSiteRouteViews/site/SinglePage";
import ShoppingCart from "./defaultSiteRouteViews/site/ShoppingCart";
import UnAuthenticatedShoppingCart from "./defaultSiteRouteViews/site/UnAuthenticatedShoppingCart";
import SingleLesson from "./defaultSiteRouteViews/site/SingleLesson";
import verifyTransaction from "./defaultSiteRouteViews/site/VerifyTransaction";
import Factor from "./defaultSiteRouteViews/site/Factor";
import Delivery from "./defaultSiteRouteViews/site/Delivery";
import Payment from "./defaultSiteRouteViews/site/Payment";
import Categories from "./defaultSiteRouteViews/site/Categories";
import Brands from "./defaultSiteRouteViews/site/Brands";
import SingleCategory from "./defaultSiteRouteViews/site/SingleCategory";
import SingleBrand from "./defaultSiteRouteViews/site/SingleBrand";
import FactorAutoPrint from "./defaultSiteRouteViews/site/FactorAutoPrint";
import PostCategories from "./defaultSiteRouteViews/site/PostCategories";
import Search from "./defaultSiteRouteViews/site/Search";


export let siteRoutes = [
    {
        path: '/login',
        name: 'Login',
        components: {site: Login},
        beforeEnter: multiguard([redirectLogin]),
    },
    // auth routes
    {
        path: '/register',
        name: 'Register',
        components: {site: Register},
        beforeEnter: multiguard([redirectLogin]),
    },
    {
        path: '/verified-cellphone',
        name: 'VerifiedCellphone',
        components: {site: VerifiedCellphone},
        beforeEnter: multiguard([loginRequired, isVerifiedCellphoneForSmsVerification]),
    },
    {
        path: '/forget-password',
        name: 'ForgetPassword',
        components: {site: ForgetPassword},
        beforeEnter: multiguard([redirectLogin]),

    },
    {
        path: '/cellphone-reset-password',
        name: 'CellphoneResetPassword',
        components: {site: CellphoneResetPassword},
        beforeEnter: multiguard([redirectLogin, isRequestCellphoneForgetPassword]),

    },
    {
        path: '/email/reset/password/:token/:email',
        name: 'EmailResetPassword',
        components: {site: EmailResetPassword},
        beforeEnter: multiguard([redirectLogin]),
    },
    {
        path: '/auth/email/verified/:id/:hash',
        name: 'VerifiedEmail',
        components: {site: VerifiedEmail},
        beforeEnter: multiguard([loginRequired]),

    },
    // products routes
    {
        path: '/products',
        name: 'Products',
        components: {site: Products},
    },
    {
        path: '/product/:name',
        name: 'Product',
        components: {site: Product},
    }, // todo name should be slug
    // order should
    {
        path: '/delivery',
        name: 'Delivery',
        components: {site: Delivery},
        beforeEnter: multiguard([loginRequired, isVerifiedCellphone]),
    },
    {
        path: '/shopping-cart',
        name: 'ShoppingCart',
        components: {site: ShoppingCart},
        beforeEnter: multiguard([loginRequired, isVerifiedCellphone]),
    },
    {
        path: '/un-authenticated-shopping-cart',
        name: 'UnAuthenticatedShoppingCart',
        components: {site: UnAuthenticatedShoppingCart},
    },
    {
        path: '/factor/:orderId',
        name: 'Factor',
        components: {site: Factor},
        beforeEnter: multiguard([loginRequired, isVerifiedCellphone]),
    },
    {
        path: '/payment',
        name: 'Payment',
        components: {site: Payment},
        beforeEnter: multiguard([loginRequired, isVerifiedCellphone]),
    },
    {
        path: '/transaction/user/:user/order/:order/verify-payment',
        name: 'verifyTransaction',
        components: {site: verifyTransaction},
        beforeEnter: multiguard([loginRequired, isVerifiedCellphone]),
    },
    // content routes
    {
        path: '/blog',
        name: 'Posts',
        components: {site: Posts},
    },
    {
        path: '/posts/:slug',
        name: 'SinglePost',
        components: {site: SinglePost},
    },
    {
        path: '/pages',
        name: 'Pages',
        components: {site: Pages},
    },
    {
        path: '/pages/:slug',
        name: 'SinglePage',
        components: {site: SinglePage},
    },
    {
        path: '/course',
        name: 'Courses',
        components: {site: Courses},
    },
    {
        path: '/course/:slug',
        name: 'SingleCourse',
        components: {site: SingleCourse},
    },
    {
        path: '/course/:courseSlug/lesson/:slug',
        name: 'SingleLesson',
        components: {site: SingleLesson},
    },
    {
        path: '/categories',
        name: 'Categories',
        components: {site: Categories}
    },
    {
        path: '/brands',
        name: 'Brands',
        components: {site: Brands}
    },
    {
        path: '/category/:slug',
        name: 'SingleCategory',
        components: {site: SingleCategory}
    },
    {
        path: '/brand/:slug',
        name: 'SingleBrand',
        components: {site: SingleBrand}
    },
    {
        path: '/post/categories',
        name: 'PostCategories',
        components: {site: PostCategories}
    },
    {
        path: '/search/type/:type/words/:words',
        name: 'Search',
        components: {site: Search},
    },
]